var map = {
	"./b2c-site-client-ach-UG.json": 1343,
	"./b2c-site-client-de-AT.json": 1344,
	"./b2c-site-client-de-DE.json": 1345,
	"./b2c-site-client-en-GB.json": 1346,
	"./b2c-site-client-en-US.json": 1347,
	"./b2c-site-client-fr-FR.json": 1348
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1342;


//////////////////
// WEBPACK FOOTER
// /home/jenkins/agent/workspace/b-apps_b2c-site_b2c-site_develop/locales ^\.\/b2c\-site\-client\-.*\.json$
// module id = 1342
// module chunks = 75